import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeaderComponent } from "./components/header/header.component";
import { RouterModule } from "@angular/router";
import { FooterComponent } from "./components/footer/footer.component";
import { ErreurComponent } from "./components/erreur/erreur.component";
import { DifficultyComponent } from "./components/difficulty/difficulty.component";
import { CtfIconComponent } from "./components/ctf-icon/ctf-icon.component";
import { ImageAssetComponent } from "./components/image-asset/image-asset.component";
import { FirstLetterPipe } from "./pipe/first-letter.pipe";
import { CountdownTimerComponent } from "./components/countdown-timer/countdown-timer.component";
import { CodeViewerComponent } from "./components/code-viewer/code-viewer.component";
import { HtmlTextComponent } from "./components/html-text/html-text.component";
import { BadgeComponent } from "./components/badge/badge.component";
import { QtmComponentLibraryModule } from "@qtm/angular";
import { DisplayWhenNullPipe } from "./pipe/display-when-null.pipe";
import { SortableHeaderComponent } from "../core/user-profile/components/sortable-header/sortable-header.component";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { TranslateModule } from "@ngx-translate/core";
import { MarkdownModule } from "ngx-markdown";

@NgModule({
  declarations: [
    SpinnerComponent,
    HeaderComponent,
    DisplayWhenNullPipe,
    SortableHeaderComponent,
    FooterComponent,
    ErreurComponent,
    DifficultyComponent,
    CtfIconComponent,
    ImageAssetComponent,
    FirstLetterPipe,
    CountdownTimerComponent,
    HtmlTextComponent,
    CodeViewerComponent,
    BadgeComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    QtmComponentLibraryModule,
    TranslateModule,
    MarkdownModule,
  ],
  exports: [
    SpinnerComponent,
    HeaderComponent,
    FooterComponent,
    ErreurComponent,
    DifficultyComponent,
    CtfIconComponent,
    ImageAssetComponent,
    FirstLetterPipe,
    CountdownTimerComponent,
    HtmlTextComponent,
    CodeViewerComponent,
    BadgeComponent,
    QtmComponentLibraryModule,
    DisplayWhenNullPipe,
    SortableHeaderComponent,
  ],
})
export class SharedModule {}
